<div class="secure-info">
    <img src="../../../../../assets/lock-shield.svg" alt="Lock icon indicating secure application">

    <span class="c11n-space-inline-left-1x c11n-space--force">
        {{ content.applicationSecureInfoMessage.heading
            .replace(content.applicationSecureInfoMessage.applicationSecureLink, emptyString) }}
        <a
            class="c11n-link pointer"
            c11n-link
            (click)="open()"
            [variant]="'secondary-independent'">
            {{ content.applicationSecureInfoMessage.applicationSecureLink }}
        </a>
    </span>
</div>

<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
<c11n-modal-dialog
    [variant]="'basic'"
    [headingText]="content.applicationSecureInfoMessage.heading"
    [primaryButtonLabel]="content.applicationSecureInfoMessage.navClose"
    (primaryClick)="close()"
    [maxWidth]="660"
    [useContentWidth]="false"
    data-cy="secure-modal"
    #secureModal>
    <div c11n-modal-dialog-body>
        <span
            class="c11n-text-md c11n-space-stack-2x"
            [innerHTML]="sanitizeHtml(content.applicationSecureInfoMessage.text1)">
        </span>
        <p #paragraphWithLinkContainer></p>

    </div>
</c11n-modal-dialog>
